/*************************************************/
/* IMAGE-STACK                                   */
/*************************************************/


export function imageStack() {
    const imageStackTopSelector = '.image-stack__inner';
    const imageStackTriggerSelector = '.image-stack__list-item';
    const imageStackTriggerActiveClass = 'image-stack__list-item--active';
    const imageStackImageSelector = '.image-stack__image-inner';
    const imageStackImageActiveClass = 'image-stack__image-inner--active';

    const init = function () {
        const triggers = document.querySelectorAll(imageStackTriggerSelector);
        if (triggers != null) {
            ['mouseenter','click'].forEach(eventName => {
                triggers.forEach(trigger => {
                    trigger.addEventListener(eventName, e => {
                        e.stopPropagation();
                        const target = e.target;
                        if(!e.target.classList.contains(imageStackTriggerActiveClass)) {
                            const componentTop = target.closest(imageStackTopSelector);
                            const itemIndex = target.dataset.index;
        
                            const triggersInComponent = componentTop.querySelectorAll(imageStackTriggerSelector);
                            const imagesInComponent = componentTop.querySelectorAll(imageStackImageSelector);
        
                            triggersInComponent.forEach(componentTrigger => {
                                componentTrigger.classList.remove(imageStackTriggerActiveClass);
                                if (componentTrigger.dataset.index == itemIndex) {
                                    componentTrigger.classList.add(imageStackTriggerActiveClass);
                                }
                            })
        
                            imagesInComponent.forEach(componentImage => {
                                componentImage.classList.remove(imageStackImageActiveClass);
                                if (componentImage.dataset.index == itemIndex) {
                                    componentImage.style.display = 'flex'; //Hard sets the flex here, so the image is lazyloaded but the transition for opacity works the next time
                                    componentImage.classList.add(imageStackImageActiveClass);
                                }
                            });
                        }
                        
                    });
                });
            })
            
        }
    };

    init();
}